import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ResizeDetectionService } from '../../../services/resize-detection.service';
import { PlanOrderDetailModel } from '../../../models/plan/plan-order-detail-model';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { PlanService } from '../../../services/plan/plan.service';
import { MealModel } from 'src/app/nutrigenic/models/home/meal-model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsService } from '../../../services/analytics/analytics.service';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss']
})
export class OrderSummaryComponent {

    mealsList: any[] = [];
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    isLoading: boolean = false;

    planOrderDetails: PlanOrderDetailModel = new PlanOrderDetailModel();
    cart:any = [];
    preSelectedWeekMeals: MealModel[] = [];

    currWeek:number = 1;
    deliveryFees:number = 3.95;
    singleDeliveryPrice: number = 3.95; // it should come from backend
    discount:number = 0;
    weeklyDeliveriesCount: number = 1;
    
    promo_discount_id:number = 0;
    promo_code:string = 'WORLDCUP';
    promo_discount_object: any = null;
    free_shipping_type: string = '';

    day:string = "";
    deliveryDate:string = "";
    dates:any = [];
    selectedDate:any;

    suggestions:any = [];
    suggestions_all:any = [];
    full_address: string = '';
    items: MenuItem[];
    activeItem: MenuItem;
    
    options:any = {};
    
    

    constructor(
        private sizedetection: ResizeDetectionService,
        private router: Router,
        private planService: PlanService,
        private spinner: NgxSpinnerService,
        private analyticsService: AnalyticsService
    ) {
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe({
                next: data => {
                    this.isDesktop = data.isDesktop;
                    this.isTablet = data.isTablet;
                    this.isMobile = data.isMobile;
                    //console.log(this.isTablet);
                },
                error: (error) => {
                    this.handleError(error); 
                }
        });

    }

    ngOnInit() {

        try{

            this.isLoading = true;
            this.spinner.show();

            if (localStorage.getItem('cookie')) {
                this.cookiePopupVisibility = false;
            } else this.cookiePopupVisibility = true;

            this.planOrderDetails = this.getPlanOrderDetails(localStorage.getItem('orderDetails'));

            // Shipping Date
            this.createShippingDateMenu();
            this.selectedDate = this.dates[0];
            let now = new Date();
            this.day = this.returnDay(now.getDay());
            
            if (localStorage.getItem('selectedDate')) {
                let selectedDate:any = localStorage.getItem('selectedDate');
                this.selectedDate = this.dates.filter((x:any)=>x.key==JSON.parse(selectedDate).key)[0];
                if(!this.selectedDate) {
                    this.selectedDate = this.dates[0];
                }
                this.deliveryDate = this.selectedDate.name;
                //console.log(this.selectedDate);
            }

            this.discount = 0;
            
            
            if (localStorage.getItem('cart')) {
                let cart:any = localStorage.getItem('cart');
                this.cart = JSON.parse(cart);
                this.preSelectedWeekMeals = this.cart[0];

                if(this.preSelectedWeekMeals[0].price != 9.5){ // in case the price was changed in the backend after the user added the meals to the cart
                    this.determineMealsBasedOnUserPreferences();
                } else {
                    this.applyDiscount();
                    this.getWeeklyDeliveriesCount();
                }

                this.spinner.hide();
                this.isLoading = false;
                
            } else {
                this.determineMealsBasedOnUserPreferences();
            }

        } catch(error){
            this.spinner.hide();
            this.isLoading = false;
            this.handleError(error);
        }
    }

    determineMealsBasedOnUserPreferences() {
        let weekTotalMeals = this.planOrderDetails.mealPerDay * this.planOrderDetails.dayPerWeek;
        this.planService.getMeals(this.planOrderDetails.allergies, [this.planOrderDetails.goal], this.planOrderDetails.categories, weekTotalMeals).subscribe( {
            next: meals => {
                try {
                    if(meals.length > 0){
                        this.preSelectedWeekMeals = this.verifyAndAdjustAmountToMatchOrderPlanWeeklyTotalMeals(meals, weekTotalMeals);
                        this.addToCart(this.preSelectedWeekMeals, this.planOrderDetails.weeks);
                        this.applyDiscount();
                        this.getWeeklyDeliveriesCount();
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    this.spinner.hide();
                    this.isLoading = false;
                }
            },
            error: (error) => {
                this.handleError(error);
                this.spinner.hide();
                this.isLoading = false;
            }

        });
    }


    countTotalMeals(meals: MealModel[]): number {
        return this.planService.countTotalMeals(meals);
    }


    verifyAndAdjustAmountToMatchOrderPlanWeeklyTotalMeals(meals: MealModel[], planWeeklyTotalMeals:number){
        let totalMealsDiff = planWeeklyTotalMeals - meals.length;

        // check if based on the preferences, the total count of meals maxed out (5 of each meal) cannot fulfill the planWeeklyTotalMeals
        if(totalMealsDiff != 0 && meals.length * 5 < planWeeklyTotalMeals){
            throw new Error("the total count of meals maxed out (5 of each meal) cannot fulfill the planWeeklyTotalMeals based on the user preferences specified");
        }
        
        if(totalMealsDiff == 0){
            meals.forEach(meal => { meal.count++; meal.isAdded = true});
            return meals;
        }

        while(totalMealsDiff != 0){
            if(totalMealsDiff > 0){
                for(let i = 0; totalMealsDiff > 0 && i < meals.length; i++){
                    meals[i].count++;
                    totalMealsDiff--;
                }
            } else if(totalMealsDiff < 0){
                // reduce list
                meals = meals.splice(totalMealsDiff);
            }
           totalMealsDiff = planWeeklyTotalMeals - this.countTotalMeals(meals);
        } 
        meals.forEach(meal => meal.isAdded = true);
        return meals;
    }


    getPlanOrderDetails(planOrderDetails: any){
         
        if (!planOrderDetails) {
            let error = {
                error: {
                    message: 'No plan details found'
                }
            }
            this.handleError(error);
            localStorage.removeItem('cart');
            this.router.navigate(['/order-flow']);
        }

        return JSON.parse(planOrderDetails);
        
      }


    returnDay(day: number) {
        let dayS = "";
        switch (day) {
            case 1: dayS = "Monday"; break;
            case 2: dayS = "Tuesday"; break;
            case 3: dayS = "Wednesday"; break;
            case 4: dayS = "Thursday"; break;
            case 5: dayS = "Friday"; break;
            case 6: dayS = "Saturday"; break;
            case 0: dayS = "Sunday"; break;
        }
        return dayS;
    }

    returnMonth(month: number) {
        let monthS = "";
        switch (month) {
            case 1: monthS = "January"; break;
            case 2: monthS = "February"; break;
            case 3: monthS = "March"; break;
            case 4: monthS = "April"; break;
            case 5: monthS = "May"; break;
            case 6: monthS = "June"; break;
            case 7: monthS = "July"; break;
            case 8: monthS = "August"; break;
            case 9: monthS = "September"; break;
            case 10: monthS = "October"; break;
            case 11: monthS = "November"; break;
            case 12: monthS = "December"; break;
        }
        return monthS;
    }

    getNextDayOfTheWeek(dayName: string, excludeToday = true, refDate = new Date()) {
        const dayOfWeek = ["sun","mon","tue","wed","thu","fri","sat"]
                          .indexOf(dayName.slice(0,3).toLowerCase());
        if (dayOfWeek < 0) return;
        refDate.setHours(0,0,0,0);
        refDate.setDate(refDate.getDate() + +!!excludeToday +
                        (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);
        return refDate;
    }

    setDate(event: any) {
        //console.log(event);
        this.deliveryDate = event.name;
    }

    createShippingDateMenu(){
        let now = new Date();
        let nowDay = now.getDay();
        let date;
        if (nowDay==1 || nowDay==2 || nowDay==3) {
            let daysUntilSaturday = (6 - now.getDay() + 7) % 7 || 7; // Ensures at least 7 days if today is Saturday
            let date = new Date(now.setDate(now.getDate() + daysUntilSaturday));
            // date = new Date(now.setDate(now.getDate() + (((6 + 7 - nowDay) % 7) || 7)));
            this.deliveryDate = this.formatDateVisual(date);
            let refDate:any = new Date();
            for(let i=0;i<3;i++){
                refDate = this.getNextDayOfTheWeek("Saturday", true, refDate);
                this.dates.push({
                    key:this.formatDate(refDate),
                    name:this.formatDateVisual(refDate)
                });
            }
            let refDate1:any = date;
            for(let i=0;i<3;i++){
                refDate1 = this.getNextDayOfTheWeek("Wednesday", true, refDate1);
                this.dates.push({
                    key:this.formatDate(refDate1),
                    name:this.formatDateVisual(refDate1)
                });
            }
        } else {
            date = new Date(now.setDate(now.getDate() + (((2 + 7 - nowDay) % 7) + 1 || 7)));
            this.deliveryDate = this.formatDateVisual(date);
            let refDate:any = new Date();
            for(let i=0;i<3;i++){
                refDate = this.getNextDayOfTheWeek("Wednesday", true, refDate);
                this.dates.push({
                    key: this.formatDate(refDate),
                    name: this.formatDateVisual(refDate)
                });
            }
            let refDate1:any = date;
            for(let i=0;i<3;i++){
                refDate1 = this.getNextDayOfTheWeek("Saturday", true, refDate1);
                this.dates.push({
                    key:this.formatDate(refDate1),
                    name:this.formatDateVisual(refDate1)
                });
            }
        }
        this.dates = this.dates.sort(function(a: any, b: any){
            return new Date(a.key.substring(0, 4), a.key.substring(5, 7)-1, a.key.substring(8, 10)).getTime() - new Date(b.key.substring(0, 4), b.key.substring(5, 7)-1, b.key.substring(8, 10)).getTime();
        });
        this.dates = this.dates.filter((date: any) => !(date.key.substring(5, 7) === '04' && date.key.substring(8, 10) === '04'));
    }

   
    handleSuccessResponse(): void {
        Notify.success('Order Created', {
            position: 'right-top',
            timeout: 3000
        });
    }

    handleError(error: any): void {
        if(error.error && error.error.type && error.error.type === 'validation'){
            let errors = error.error.message;
            Object.entries(errors).forEach(([key, value]) => {
                console.log(key, value);
                error = (value as string[])[0];
                Notify.failure(error, {
                    position: 'right-top',
                    timeout: 3000
                });
            });
        } else {
            error = error.message ?? 'Internal error - Could not complete the operation';
                Notify.failure(error, {
                position: 'right-top',
                timeout: 3000
            });
        }
    }
    
   
    handleErrorFields(): void {
        Notify.failure('Insert all required fields', {
            position: 'right-top',
            timeout: 3000
        });
    }
   

    getWeeklyDeliveriesCount() {
        this.planService.getWeeklyDeliveriesCount(this.planOrderDetails.dayPerWeek, this.planOrderDetails.mealPerDay).subscribe(
            (weeklyDeliveriesCount) => this.weeklyDeliveriesCount = weeklyDeliveriesCount
        );
    }

    getDefaultTotalDeliveryFees(orderWeeks: number) {
        if(this.free_shipping_type) {
            if(this.free_shipping_type === 'entire_order') {
                return 0;
            } else if(this.free_shipping_type === 'first_week') {
                return (this.weeklyDeliveriesCount * this.singleDeliveryPrice) * (orderWeeks - 1);
            }
        }
        return this.weeklyDeliveriesCount * this.singleDeliveryPrice * orderWeeks;
    }

    getDeliveryFeesFirstWeek() {
        if(this.free_shipping_type) {
            return 0;
        }
        return this.weeklyDeliveriesCount * this.singleDeliveryPrice;
    }

    
    getWeekSubTotalPrice() {
      let total = 0;
      if (this.cart.length > 0) {
        this.cart[0].forEach((meal:MealModel) => {
            total += meal.price * meal.count;
        });
      }
      return Number(total).toFixed(2);
    }

    getWeekDefaultTotalPrice() {
        let total = +this.getWeekSubTotalPrice();
        total =  total + this.weeklyDeliveriesCount * this.singleDeliveryPrice;
        return Number(total).toFixed(2);
    }

    getFullOrderSubTotalPrice() {
        let total = 0;
        this.cart.forEach((all:any) => {
            all.forEach((added:any) => {
                if (added.isAdded == true)
                total += added.price * added.count;
            });
        });
        
        return Number(total).toFixed(2);
    }

    getFullOrderTotalPrice() {
        let total = +this.getFullOrderSubTotalPrice();
        total = total + this.deliveryFees - this.getDiscount();
        return Number(total).toFixed(2);
    }
    
    getFirstWeekTotalPrice() {
        let total = +this.getWeekSubTotalPrice();
        //total = total + parseFloat(this.getAddonsTotal());
        total =  total + this.getDeliveryFeesFirstWeek() - (+this.getDiscountFirst());
        return Number(total).toFixed(2);
    }

    getDiscount() {
        let total = +this.getFullOrderSubTotalPrice();
        return total * this.discount / 100;
    }

    getDiscountFirst() {
        let total = 0;
        if (this.cart.length > 0) {
          this.cart[0].forEach((all:MealModel) => {
              if (all.isAdded == true)
                total += all.price * all.count;
          });
        }
        
        return Number(total * this.discount / 100).toFixed(2);
    }

    getDiscountedMealPrice() {
      if(this.cart.length > 0){
        return Number(this.cart[0][0].price - (this.cart[0][0].price * this.discount / 100)).toFixed(2);
      }
      return 0;
    }
    
    discountVisual() {
        return this.getDiscountFirst();
    }

    previousWeek() {
        if (this.currWeek != 1)
        this.currWeek--;
    }

    nextWeek() {
        if (this.currWeek<this.planOrderDetails.weeks)
        this.currWeek++;
    }

    applyDiscount() {
        localStorage.removeItem('promo_discount');
        localStorage.removeItem('promo_discount_id');
        localStorage.removeItem('promo_discount_object');
        localStorage.removeItem('promo_code');
        localStorage.removeItem('free_shipping_type');

        const type = this.planOrderDetails.type
        //console.log(type);
        if(this.promo_code == '') {

            this.promo_discount_id = 0;
            this.promo_discount_object = null;
            this.free_shipping_type = '';

            

            this.discount = 0;
            localStorage.setItem('promo_discount', this.discount.toString());
        } else {
            this.planService.activatePromoCode({code: this.promo_code, type: type.toLowerCase() }).subscribe({
                next: this.handleAssignResponsePromoCode.bind(this),
                error: this.handleErrorPromoCode.bind(this)
            });
        }
    }

    handleAssignResponsePromoCode(response: any): void {
        let promo_discount = response.body.discount.discount;
        this.promo_discount_id = response.body.id;
        this.discount = parseFloat(promo_discount);
        this.promo_discount_object = null;
        //console.log(this.discount);

        localStorage.setItem('promo_discount', this.discount.toString());
        localStorage.setItem('promo_discount_id', this.promo_discount_id.toString());

        this.free_shipping_type = response.body.free_shipping_type;
        this.deliveryFees = this.getDeliveryFeesFirstWeek();

        if(response.body.discount_type == 1) {
            this.promo_discount_id = response.body.id;
            localStorage.setItem('promo_code', this.promo_code);
            localStorage.setItem('free_shipping_type', this.free_shipping_type.toString());
        } else {
            this.promo_discount_object = response.body;
            this.discount = response.body.discount.firstWeekDiscount;
            this.promo_discount_id = response.body.id;
            
            localStorage.setItem('promo_code', this.promo_code);
            localStorage.setItem('promo_discount', this.discount.toString());
            localStorage.setItem('promo_discount_object', JSON.stringify(this.promo_discount_object));
        }

        //console.log(this.discount);
        Notify.success('Discount code activated', {
            position: 'right-top',
            timeout: 3000
        });
    }

    handleErrorPromoCode(): void {
        this.promo_code = '';
        this.promo_discount_id = 0;
        this.promo_discount_object = null;
        this.free_shipping_type = '';

        localStorage.removeItem('promo_discount');
        localStorage.removeItem('promo_discount_id');
        localStorage.removeItem('promo_discount_object');
        localStorage.removeItem('promo_code');
        localStorage.removeItem('free_shipping_type');


        this.discount = 0;
        localStorage.setItem('promo_discount', this.discount.toString());

        Notify.failure('Discount code not valid or already used', {
            position: 'right-top',
            timeout: 3000
        });
    }

    formatDate(date: Date, separator = "-") {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Two-digit month
        const day = String(date.getDate()).padStart(2, '0'); // Two-digit day

        return `${year}${separator}${month}${separator}${day}`;
    }

    formatDateSlash(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
        const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits

        return `${year}/${month}/${day}`;
    }

    formatDateVisual(date: Date) {
        const dayName = this.returnDay(date.getDay()); // Get day name
        const day = String(date.getDate()).padStart(2, '0'); // Ensure two-digit day
        const monthName = this.returnMonth(date.getMonth() + 1); // Get month name

        return `${dayName} ${day} ${monthName}`;
    }   

    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;
    showMainCheckout: boolean = false;
    acceptCookie() {
        localStorage.setItem('cookie', "1");
        this.cookiePopupVisibility = false;
    }
    customizeCookie() {
        this.cookiePopupVisibility = false;
        this.customCookiePopupVisibility = true;
    }
    rejectCookie() {

    }
    acceptCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility= false;
    }
    customizeCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility = false;
    }
    rejectCookieOpen() {
        this.customCookiePopupVisibility = false;
    }

    goToOrderCheckout(){
       localStorage.setItem('selectedDate', JSON.stringify(this.selectedDate));
       this.addToCart(this.preSelectedWeekMeals, this.planOrderDetails.weeks);
       this.trackEvent('begin_checkout');
       this.router.navigate(['/order-checkout']);
    }


    trackEvent(eventName: string) {
        const meal_plans:any = [{id:1, name:"Flexi", value:"Flexi"}, {id:2, name:"Commit", value:"Commit"}, {id:3, name:"Custom", value:"Expert"}];
        let type = meal_plans.filter((x:any)=>x.value==this.planOrderDetails.type)[0].id;
        this.analyticsService.trackEvent(eventName, {
            ecommerce: {
                items: [{
                    item_id: type,
                    item_name: meal_plans.filter((x:any)=>x.id==type)[0].name,
                    price: parseFloat(this.getFirstWeekTotalPrice()),
                    quantity: 1
                }],
            },
        });
    }


    addToCart(preSelectedWeekMeals: MealModel[], weeks: number) {
        if(preSelectedWeekMeals && preSelectedWeekMeals.length > 0) {
            let cart:any = [];
            for(let week = 0; week < weeks; week++) {
                var weeklyMeals = preSelectedWeekMeals;
                cart.push(weeklyMeals);
            }

            this.cart = cart;
            localStorage.setItem('cart', JSON.stringify(cart));
            this.trackEvent('add_to_cart');
        }
    }


    @ViewChild('mealsContainer') mealsContainer!: ElementRef;

    scrollLeft() {
        this.mealsContainer.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
    }

    scrollRight() {
        this.mealsContainer.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
    }

    editMeals() {
        let old_allergies:any = localStorage.getItem('allergies');
        let allergies:any = JSON.parse(old_allergies);
        var data: any = {
            type: this.planOrderDetails.type,
            weeks: this.planOrderDetails.weeks,
            mealPerDay: this.planOrderDetails.mealPerDay,
            dayPerWeek: this.planOrderDetails.dayPerWeek,
            allergies: allergies
        }
        localStorage.setItem('cart', JSON.stringify(this.cart))
        localStorage.setItem('selectedDate', JSON.stringify(this.selectedDate))
        this.router.navigate(['/select-meals'], { queryParams: data });
    }

   goToQuestions(){
    this.router.navigate(['/order-flow']);
   }
}

